function EditBtn({ disabled = false, onClick = () => {} }) {
  if (disabled) {
    return (
      <>
        <div className="w-50px text-center">
          <button className="btn btn-outline-default btn-sm" disabled>
            <i className="fas fa-edit"></i>
          </button>
        </div>
      </>
    );
  }
  return (
    <>
      <div className="w-50px text-center">
        <button onClick={onClick} className="btn btn-outline-default btn-sm" disabled={false}>
          <i className="fas fa-edit text-theme"></i>
        </button>
      </div>
    </>
  );
}

export default EditBtn;
